import React from 'react';
import { useIntl } from 'react-intl';
import { Menu, MenuPropTypes } from '../Dropdown';

const SortMenu = ({ id, title, sort, onSelect, isOpen, options }) => {
  const intl = useIntl();
  return (
    <Menu
      id={id}
      title={title}
      items={options}
      onSelect={onSelect}
      isSelected={option => option.key === sort}
      getKey={option => option.key}
      getText={option => intl.formatMessage(option.sortName)}
      isOpen={isOpen}
    />
  );
};

SortMenu.propTypes = MenuPropTypes;

export default SortMenu;
